export default __webpack_public_path__ + "static/media/near-bu.90d4e9d4.svg";